// Shared risk-scale primitives for the Market Health card.
//
// Extracted from the former ScoreGauge so the risk-pressure bar, the score
// history chart, and the strategy/drawdown charts can all share one source of
// truth for the zone palette and the high-is-risk color rule, without any of
// them importing a component.

// Solid zone colors used across DimensionBars, ScoreChart trade markers,
// StrategyChart, and DrawdownChart.
export const ZONE_COLORS = { red: '#dc3545', yellow: '#ffc107', green: '#28a745' };

const isFiniteNumber = (v) => typeof v === 'number' && Number.isFinite(v);

/**
 * Domain-aware, high-is-risk color for the canonical risk score. Green below
 * the risk boundary, red at or above it — boundary equality is in the risk
 * band. Returns a CSS hex color. For null/non-finite score or missing
 * boundary, returns a neutral gray. The color depends only on which side of
 * `riskBoundary` the score sits; the score itself is displayed unchanged.
 */
export const riskScoreColor = (score, riskBoundary) => {
  if (!isFiniteNumber(score)) return '#adb5bd';
  if (!isFiniteNumber(riskBoundary)) return '#adb5bd';
  return score >= riskBoundary ? ZONE_COLORS.red : ZONE_COLORS.green;
};
